import LineChartCustom from "../../components/Incidents/charts/LineChart";

const SumOfAmountByDate = ({ data }) => {
  const xLabels = data.map((item) => item.date);
  const values = data.map((item) => Number(item.amount.toFixed(2)));

  const formatCurrency = (value) => {
    if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
    if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
    return `$${value}`;
  };
  const series = [
    {
      data: values,
      curve: "linear",
    },
  ];
  return (
    <LineChartCustom
      xLabels={xLabels}
      series={series}
      yAxis={[
        {
          valueFormatter: formatCurrency,
        },
      ]}
      marginBottom={80}
      tickLabelStyle={{
        angle: 45,
        textAnchor: "start",
      }}
    />
  );
};

export default SumOfAmountByDate;
